import { useEffect, useRef } from "react";
import useGatheringFilterSortStore from "./useGatheringFilterSortStore";

const useGatheringFilterSortRefreshListener = (fn: () => void) => {
	const refreshTopic = useGatheringFilterSortStore((state) => state.refreshTopic);
	const fnRef = useRef(fn);
	useEffect(() => {
		fnRef.current = fn;
	}, [fn]);
	useEffect(() => {
		const { unsubscribe } = refreshTopic.on("refresh", fnRef.current);
		return unsubscribe;
	}, [refreshTopic]);
};
export default useGatheringFilterSortRefreshListener;
